import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const ConfigureApps = () => {
  const title = 'Configure Apps';

  return (
    <Container maxWidth="xl">
      <Typography variant="h1">{title}</Typography>
    </Container>
  );
}

export default ConfigureApps;
